module.exports = __webpack_public_path__ + "static/media/product-28.e5350eb1.jpg";